import { render, staticRenderFns } from "./SecondChannel.vue?vue&type=template&id=7f0eeb81&scoped=true"
import script from "./SecondChannel.vue?vue&type=script&lang=js"
export * from "./SecondChannel.vue?vue&type=script&lang=js"
import style0 from "./SecondChannel.vue?vue&type=style&index=0&id=7f0eeb81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0eeb81",
  null
  
)

export default component.exports